export default {
  hidden_rates:
    'Unele metode de plată au și propria rată, stabilită de suportul platformei. Acestea se aplică în locul acestei rate.',
  title: 'Comisioane de procesare',
  subtitle: 'Comisionul de procesare perceput {{company}} la plățile online, pentru a acoperi comisioanele Stripe.',
  card_title: 'Comision de procesare',
  status: {
    inherited_tag: 'Implicit partener',
    inherited: 'Acest restaurant plătește comisionul de procesare implicit al tău.',
    custom_tag: 'Personalizat',
    custom: 'Acest restaurant are propriul comision de procesare, care îl înlocuiește pe cel implicit.',
    none_title: 'Niciun comision de procesare setat',
    none: 'Nici acest restaurant, nici setarea ta implicită nu au un tarif. Dacă nu ai confirmat o marjă de 0% pe pagina comisioanelor de procesare ale partenerului, restaurantul nu poate fi lansat și nu poate primi plăți online; cu această confirmare, nu i se percepe nimic, iar tu plătești comisioanele Stripe pentru plățile sale.',
  },
  buttons: {
    set_custom: 'Setează un comision personalizat',
    edit: 'Editează',
    cancel: 'Anulează',
    save: 'Salvează',
    reset_to_default: 'Resetează la implicit',
  },
  toasts: {
    load_error: 'Comisionul de procesare nu a putut fi încărcat.',
    failed_to_save_changes: 'Comisionul de procesare nu a putut fi salvat.',
    changes_got_saved: 'Comision de procesare salvat',
    reset_to_default: 'Acest restaurant folosește acum comisionul de procesare implicit al tău.',
  },
};
